import { render, staticRenderFns } from "./PrazosLista.vue?vue&type=template&id=3e828df0&scoped=true&"
import script from "./PrazosLista.vue?vue&type=script&lang=js&"
export * from "./PrazosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e828df0",
  null
  
)

export default component.exports